// core-ui dependencies
import 'assets/js/polyfill';
// --------------------

import React from 'react';
import ReactDOM from 'react-dom';
import Routing from 'components/Routing';

import store from 'redux/store';

import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <Routing />
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js